module.exports = __webpack_public_path__ + "static/img/about_design.813e79f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_design.svg
// module id = 156
// module chunks = 2